import { getDataFromCache, addFileToCache, manageCacheTime } from '../common/cache';

export const activateFuncionalities = (category) =>{
  const cacheData = getDataFromCache('active-functionalities');

  /* eslint-disable no-nested-ternary*/
  let activates = manageCacheTime('active-functionalities') ? null : cacheData ? cacheData.conf[category] : null;

  /* eslint-disable global-require */
  /* eslint-disable no-else-return*/
  if (window.location.origin.indexOf(':9000') >= 0 || window.location.origin.indexOf('slots-ux') >= 0) {
    if (!activates){
      const data = require('../static/json/active-functionalities.json');
      activates = data[category];
      addFileToCache('active-functionalities', { conf: data, timestamp: new Date().getTime()});
    }
    return activates;
  } else {
    if (!activates){
      jQuery.ajax({
        url: '/static/json/active-functionalities.json',
        cache: true,
        async: false,
        dataType: 'json',
        success: (data) => {
          activates = data[category];
          addFileToCache('active-functionalities', { conf: data, timestamp: new Date().getTime()});
        }
      });
    }
    return activates;
  }
};

export const listProductsSwimmingPools = () =>{
  const cacheData = getDataFromCache('list-products-swimmingpools');

  /* eslint-disable no-nested-ternary*/
  let activates = manageCacheTime('list-products-swimmingpools') ? null : cacheData ? cacheData.info : null;

  /* eslint-disable global-require */
  /* eslint-disable no-else-return*/
  if (window.location.origin.indexOf(':9000') >= 0 || window.location.origin.indexOf('slots-ux') >= 0) {
    if (!activates){
      const data = require('../static/json/iconProductsList.json');
      activates = data;
      addFileToCache('list-products-swimmingpools', { info: data, timestamp: new Date().getTime()});
    }
    return activates;
  } else {
    if (!activates){
      jQuery.ajax({
        url: '/static/json/iconProductsList.json',
        cache: true,
        async: false,
        dataType: 'json',
        success: (data) => {
          activates = data;
          addFileToCache('list-products-swimmingpools', { info: data, timestamp: new Date().getTime()});
        }
      });
    }
    return activates;
  }
};

export const splitOrder = () =>{
  const cacheData = getDataFromCache('split-order');

  /* eslint-disable no-nested-ternary*/
  let activates = manageCacheTime('split-order') ? null : cacheData ? cacheData.info : null;

  /* eslint-disable global-require */
  /* eslint-disable no-else-return*/
  if (window.location.origin.indexOf(':9000') >= 0 || window.location.origin.indexOf('slots-ux') >= 0) {
    if (!activates){
      const data = require('../static/json/splitorder.json');
      activates = data;
      addFileToCache('split-order', { info: data, timestamp: new Date().getTime()});
    }
    return activates;
  } else {
    if (!activates){
      jQuery.ajax({
        url: '/static/json/splitorder.json',
        cache: true,
        async: false,
        dataType: 'json',
        success: (data) => {
          activates = data;
          addFileToCache('split-order', { info: data, timestamp: new Date().getTime()});
        }
      });
    }
    return activates;
  }
};

export const getMounting = () =>{
  const cacheData = getDataFromCache('mounting');

  /* eslint-disable no-nested-ternary*/
  let activates = manageCacheTime('mounting') ? null : cacheData ? cacheData.info : null;

  /* eslint-disable global-require */
  /* eslint-disable no-else-return*/
  if (window.location.origin.indexOf(':9000') >= 0 || window.location.origin.indexOf('slots-ux') >= 0) {
    if (!activates){
      const data = require('../static/json/mounting.json');
      activates = data;
      addFileToCache('mounting', { info: data, timestamp: new Date().getTime()});
    }
    return activates;
  } else {
    if (!activates){
      jQuery.ajax({
        url: '/static/json/mounting.json',
        cache: true,
        async: false,
        dataType: 'json',
        success: (data) => {
          activates = data;
          addFileToCache('mounting', { info: data, timestamp: new Date().getTime()});
        }
      });
    }
    return activates;
  }
};



// WEBPACK FOOTER //
// ./src/_override/api/api.js